<template>
  <div class="height100 flex flex-col" style="width: 80%;margin: 0 auto">
    <div class="bg-fff margin-bottom-10">
      <div class="flex flex-between flex-align-center global-padd">
        <div class="font-18"><span class="font-16 pointer" @click="$router.push('/teammanagement')"><i class="el-icon-s-home font-18 margin-rt-5"></i>团队单位</span><span class="font-16"><i class="el-icon-arrow-right"></i>{{teamData.teamName}}</span></div>
<!--        <div>-->
<!--          <el-button type="primary" size="small" @click="tocreate">-->
<!--            <i class="el-icon-plus" style="margin-right: 5px"></i>上传文档-->
<!--          </el-button>-->
<!--        </div>-->
      </div>
      <div class="global-line"></div>
      <div class="flex flex-between" style="padding: 15px 30px;flex-wrap:nowrap">
        <div style="line-height: 32px ;">
          <div class="font-bold font-20">{{teamData.teamName}}</div>
          <div class="flex">
            <div ><span class="label">所属单位：</span><span class="value" :title="teamData.parentUnit">{{teamData.parentUnit}}</span></div>
            <div><span class="label">成立时间：</span><span class="value">{{teamData.teamFoundTime | dateFormat('yyyy-MM-dd')}}</span></div>
          </div>
          <div class="flex">
            <div ><span class="label">团队负责人：</span><span class="value">{{teamData.teamLeaderName}}</span></div>
            <div ><span class="label">联系电话：</span><span class="value">{{teamData.teamLeaderPhone}}</span></div>
            <div ><span class="label">所在区域：</span><span class="value" :title="teamData.areaName">{{teamData.areaName}}</span></div>
          </div>
          <div><span class="label">团队介绍：</span>{{teamData.teamIntro}}</div>
        </div>
        <img style="width: 150px;height: 150px" :src="teamData.teamLogo" alt="">
      </div>



  </div>
    <div class="global-padd-15 bg-fff">
      <el-tabs v-model="activeName"  @tab-click="handleClick">
        <el-tab-pane   name="first">
          <span style="padding: 20px" slot="label">
            <el-badge :value="needSH" :hidden="needSH==0" class="item" title="待审核数">
              团队成员
            </el-badge>
            </span>
        </el-tab-pane>
        <el-tab-pane name="second">
          <span slot="label">
            <el-badge :value="needSH2" :hidden="needSH2==0" class="item" title="待审核数">
              付款记录
            </el-badge>
            </span>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div class="global-line"></div>
    <div v-if="activeName=='first'" class="flex1 global-padd-15 bg-fff">
      <el-table height="100%" :data="tableData"
                :header-cell-style="{
                  background:'#f1f1f1'
                }"
                border>
        <el-table-column label="序号" width="100px">
          <template slot-scope="scope">
            <span>{{scope.$index + 1}}</span>
          </template>
        </el-table-column>
        <el-table-column label="照片"  >
          <template slot-scope="scope">
            <img :src="scope.row.memberPhoto" alt="" class="memberPhoto">
          </template>
        </el-table-column>
        <el-table-column label="姓名"  prop="memberName">
        </el-table-column>
        <el-table-column label="性别" prop="memberSex" >
          <template slot-scope="scope">
            {{scope.row.memberSex==0?'男':'女'}}
          </template>
        </el-table-column>
        <el-table-column label="年龄"  prop="teamLeaderName" >
          <template slot-scope="scope">
            {{scope.row.memberIdCard | age}}
          </template>
        </el-table-column>
        <el-table-column label="类型" >
          <template slot-scope="scope">
            <div>{{scope.row.memberType==0?'普通成员':'教练'}}</div>
          </template>
        </el-table-column>
        <el-table-column label="身份证号" prop="memberIdCard" width="200">
        </el-table-column>
        <el-table-column label="擅长项目/所在项目" width="200"  prop="skillSport">
<!--          <template slot-scope="scope">-->
<!--            <span v-if="new Date().getTime()>scope.row.teamExpireTime" style="color: #4680FE">已过期</span>-->
<!--            <span v-else-if="new Date().getTime()<scope.row.teamExpireTime" style="color: green">生效中</span>-->
<!--            <span v-else style="color: red">未入会</span>-->
<!--          </template>-->
        </el-table-column>
        <el-table-column label="审核状态" >
          <template slot-scope="scope">
            <span v-if="scope.row.checkResult==0" style="color: #4680FE">待审核</span>
            <span v-if="scope.row.checkResult==1" style="color: green">通过</span>
            <span v-if="scope.row.checkResult==2" style="color: red">拒绝</span>
          </template>
        </el-table-column>
        <!--        <el-table-column label="上传时间" min-width="140">-->
        <!--          <template slot-scope="scope">-->
        <!--            {{scope.row.createTime | dateFormat('yyyy-MM-dd hh:mm')}}-->
        <!--          </template>-->
        <!--        </el-table-column>-->
        <!--        <el-table-column label="审核状态"  width="100">-->
        <!--          <template slot-scope="scope">-->
        <!--            <span class="" v-if="scope.row.checkState==0">待审核</span>-->
        <!--            <span class="font-success" v-if="scope.row.checkState==1">已同意</span>-->
        <!--            <span class="font-warning" v-if="scope.row.checkState==2">已驳回</span>-->
        <!--          </template>-->
        <!--        </el-table-column>-->
        <el-table-column label="操作"  prop="totalCostMoney">
          <template slot-scope="scope">
            <el-button type="text" v-if="scope.row.checkResult==0" @click="agree(scope.row)"><span style="text-decoration: underline">审核</span></el-button>
            <el-button type="text" v-if="scope.row.checkResult!=0" @click="agree(scope.row)"><span style="text-decoration: underline">查看</span></el-button>
            <!--                        <el-button type="text" @click="TransactionDetails(scope.row)">删除</el-button>-->
          </template>
        </el-table-column>
      </el-table>
    </div>
<!--    <div class="text-center global-padd bg-fff">-->
<!--      <el-pagination-->
<!--          @current-change="handleCurrentChange"-->
<!--          :current-page.sync="form.page"-->
<!--          :page-size="10"-->
<!--          layout="total, prev, pager, next"-->
<!--          :total="form.total">-->
<!--      </el-pagination>-->
<!--    </div>-->
    <div v-if="activeName=='second'" class="flex1 global-padd-15 bg-fff">
      <el-table height="100%" :data="tableData2"
                :header-cell-style="{
                  background:'#f1f1f1'
                }"
                border>
        <el-table-column label="序号" width="100px">
          <template slot-scope="scope">
            <span>{{scope.$index + 1}}</span>
          </template>
        </el-table-column>
        <el-table-column label="缴纳年份" prop="payYear" >
        </el-table-column>
        <el-table-column label="付款人"  prop="payUserName">
        </el-table-column>
        <el-table-column label="付款账号" prop="payAccount" >
        </el-table-column>
        <el-table-column label="提交时间"  >
            <template slot-scope="scope">
              {{scope.row.payTime | dateFormat('yyyy-MM-dd hh:mm')}}
            </template>
        </el-table-column>
        <el-table-column label="审核状态" >
          <template slot-scope="scope">
            <span v-if="scope.row.checkResult==0" style="color: #4680FE">待审核</span>
            <span v-if="scope.row.checkResult==1" style="color: green">通过</span>
            <span v-if="scope.row.checkResult==2" style="color: red">拒绝</span>
          </template>
        </el-table-column>
        <!--        <el-table-column label="上传时间" min-width="140">-->
        <!--          <template slot-scope="scope">-->
        <!--            {{scope.row.createTime | dateFormat('yyyy-MM-dd hh:mm')}}-->
        <!--          </template>-->
        <!--        </el-table-column>-->
        <!--        <el-table-column label="审核状态"  width="100">-->
        <!--          <template slot-scope="scope">-->
        <!--            <span class="" v-if="scope.row.checkState==0">待审核</span>-->
        <!--            <span class="font-success" v-if="scope.row.checkState==1">已同意</span>-->
        <!--            <span class="font-warning" v-if="scope.row.checkState==2">已驳回</span>-->
        <!--          </template>-->
        <!--        </el-table-column>-->
        <el-table-column label="操作"  prop="totalCostMoney">
          <template slot-scope="scope">
            <el-button type="text"  @click="look(scope.row)"><span style="text-decoration: underline;margin-right: 20px">付款截图</span></el-button>
            <!--                        <el-button type="text" @click="TransactionDetails(scope.row)">删除</el-button>-->
            <el-dropdown v-if="scope.row.checkResult==0" ref="dropdown-el" :data="scope.row" @command="handleCommand" >
              <span class="el-dropdown-link">
                <span style="color:#409EFF ">审核</span><i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="1">同意</el-dropdown-item>
                <el-dropdown-item command="2">拒绝</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
    </div>
<!--        <div class="text-center global-padd bg-fff" v-if="activeName=='second'">-->
<!--          <el-pagination-->
<!--              @current-change="handleCurrentChange"-->
<!--              :current-page.sync="form2.page"-->
<!--              :page-size="10"-->
<!--              layout="total, prev, pager, next"-->
<!--              :total="form2.total">-->
<!--          </el-pagination>-->
<!--        </div>-->
    <el-drawer
        title="成员资料"
        :visible.sync="drawer"
        :direction="direction"
    >
      <div style="padding:20px;line-height: 40px">
        <div class="flex flex-between margin-bottom-20 flex-align-center">
          <div>照片</div>
          <img style="width: 60px;height: 60px" :src="agreeData.memberPhoto" alt="">
        </div>
        <div class="global-line "></div>
        <div class="flex flex-between flex-align-center ">
          <div>{{agreeData.memberName}}</div>
          <div>{{agreeData.memberIdCard | age}}岁
          <i v-if="agreeData.memberSex==0" class="el-icon-male" style="color: #409EFF"></i>
          <i v-if="agreeData.memberSex==1" class="el-icon-female" style="color: palevioletred"></i>
          </div>
        </div>
        <div class="global-line "></div>
        <div class="flex flex-between flex-align-center ">
          <div>学龄段</div>
          <div>{{agreeData.memberLevel || "未填"}}</div>
        </div>
        <div class="global-line "></div>
        <div class="flex flex-between flex-align-center ">
          <div>身份证号</div>
          <div>{{agreeData.memberIdCard}}</div>
        </div>
        <div class="global-line "></div>
        <div class="flex flex-between flex-align-center">
          <div>联系电话</div>
          <div>{{agreeData.memberPhone}}</div>
        </div>
        <div class="global-line "></div>
        <div class="flex flex-between flex-align-center">
          <div>擅长项目</div>
          <div>{{agreeData.skillSport}}</div>
        </div>
        <div class="global-line"></div>
        <div class=" flex flex-between flex-align-center">
          <div>个人介绍</div>
          <div style="max-width: 250px; line-height: 20px">{{agreeData.memberIntro}}</div>
        </div>
        <div class="global-line"></div>
        <div class="">
          <div class="margin-bottom-20">资质证书</div>
          <div class="flex text-center">
            <div class=" margin-rt-15">
              <el-image
                  style="width: 100px; height: 100px"
                  :src="agreeData.identityObjectkey"
                  :preview-src-list="[agreeData.identityObjectkey]">
              </el-image>
              <div>{{agreeData.memberType==0?'学籍证书':'教练证书'}}</div>
            </div>
            <div class=" margin-rt-15">
              <el-image
                  style="width: 100px; height: 100px"
                  :src="agreeData.idCardFrontObjectkey"
                  :preview-src-list="[agreeData.idCardFrontObjectkey]">
              </el-image>
              <div>身份证正面</div>
            </div>
            <div>
              <el-image
                  style="width: 100px; height: 100px"
                  :src="agreeData.idCardBackObjectkey"
                  :preview-src-list="[agreeData.idCardBackObjectkey]">
              </el-image>
              <div>身份证反面</div>
            </div>
          </div>
        </div>
        <div class="global-line"></div>
        <div>
          <div><span class="margin-rt-10">参赛经历</span><i @click="dialogVisible2=true" class="el-icon-circle-plus-outline" style="cursor: pointer;color: #409EFF"></i></div>
          <el-timeline style="line-height: 18px">
            <el-timeline-item
                v-for="(activity, index) in exp"
                :key="index"
                :timestamp="dateFormatCustom(activity.experienceBeginTime, 'yyyy年MM月dd日')">
              {{activity.experienceTitle}}
            </el-timeline-item>
          </el-timeline>
        </div>

        <div class="text-center" v-if="agreeData.checkResult==0">
          <el-button type="primary" @click="agreeit(1)">同意</el-button>
          <el-button type="danger" @click="dialogVisible=true">驳回</el-button>
        </div>
      </div>
    </el-drawer>
    <el-dialog
        title="参赛经验"
        :visible.sync="dialogVisible2"
        width="450px"
    >
      <div>
        <el-form v-model="form3">
          <el-form-item label="参赛时间：">
            <el-date-picker
                style="width: 180px"
                v-model="form3.experienceBeginTime"
                type="date"
                size="small"
                value-format="timestamp"
                placeholder="参赛时间">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="参赛内容：">
            <el-input size="small"
                      style="width:300px"
                      rows="5"
                      clearable
                      type="textarea"
                      v-model="form3.experienceTitle"
                      placeholder="参赛内容"
            >
            </el-input>
          </el-form-item>
        </el-form>

      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible2=false">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
        title="驳回理由"
        :visible.sync="dialogVisible"
        width="30%"
    >
      <div>
        <el-input size="small"
                  style="width:100%"
                  rows="5"
                  clearable
                  type="textarea"
                  v-model="checkRemark"
                  placeholder="请输入驳回理由"
        >
        </el-input>
      </div>
      <span slot="footer" class="dialog-footer">
    <el-button @click="dialogClose">取 消</el-button>
    <el-button type="primary" @click="agreeit(2)">确 定</el-button>
  </span>
    </el-dialog>
    <el-image
        ref="lookImg"
        style="width: 0px; height: 0px"
        :src="imgUrl"
        :preview-src-list="[imgUrl]">
    </el-image>
  </div>
</template>

<script>
export default {
  name: 'docListdetail',
  data(){
    return {
      imgUrl:'',
      needSH:0,
      exp:[],
      needSH2:0,
      dialogVisible:false,
      dialogVisible2:false,
      checkRemark:'',
      activeName:'first',
      teamData:{},
      agreeData:{},
      drawer: false,
      direction: 'rtl',
      tableData:[],
      tableData2:[],
      form3:{
        objectType:'team_member',
        experienceBeginTime:'',
        experienceTitle:''
      },
      form:{
        // keyword:'',
        // checkState:undefined,
        // category:undefined,
        page:1 ,
        total:0
      },
      payId:'',
      command:'',
      form2:{
        // keyword:'',
        // checkState:undefined,
        // category:undefined,
        page:1 ,
        total:0
      },
    }
  },
  mounted () {
    this.getTeam()
    this.form.teamId=this.$route.params.id
    this.form2.teamId=this.$route.params.id
    this.getList()
    this.getList2()
  },
  watch:{
    dialogVisible(){
      if(this.dialogVisible==false){
        this.checkRemark=undefined
      }
    },
    dialogVisible2(){
      if(this.dialogVisible2==false){
        this.form3={
          objectType:'team_member',
              experienceBeginTime:'',
              experienceTitle:''
        }
      }
    }
  },
  methods:{
    submit(){
      this.form3.objectId=this.agreeData.memberId
      this.$http.get('/rest/experience/modify', this.form3,res => {
        this.$message.success('提交完成！')
        this.getEXP(this.agreeData.memberId)
        this.dialogVisible2=false
      })
    },
    paySH(){
      console.log('付款')
      if(!this.checkRemark&&this.command!=1){
        this.$message.error("请填写驳回原因！")
        return
      }
      this.$confirm('确认'+(this.command==1?'同意':'拒绝')+'吗？')
      .then(() => {
        this.$http.get('/rest/team/pay/check', {payId:this.payId,checkResult:this.command,checkRemark:this.checkRemark},res => {
          this.$message.success('审核完成！')
        })
        this.dialogVisible=false
        this.payId=''
        setTimeout(this.getList2,1000)
      })
      .catch(() => {
      });
    },
    handleCommand(command) {
      // console.log(command,this.$refs["dropdown-el"],this.$refs["dropdown-el"].$attrs.data.recordId)
      // this.$message('click on item ' + command);
      // let payId=
      this.payId=this.$refs["dropdown-el"].$attrs.data.recordId
      this.command=command
      if(command==1){
        this.paySH()
      }else{
        this.dialogVisible=true
      }

    },
    dialogClose(){
      this.dialogVisible=false
    },
    agreeit(type){
      if(!this.payId){
        console.log('成员')
        if(!this.checkRemark&&type!=1){
          this.$message.error("请填写驳回原因！")
          return
        }
        this.$confirm('确认'+(type==1?'同意':'驳回')+'吗？')
        .then(() => {
          this.$http.get('/rest/team/member/check', {memberId:this.agreeData.memberId,checkResult:type,checkRemark:this.checkRemark},res => {
            this.$message.success('审核完成！')
          })
          this.drawer=false
          this.dialogVisible=false
          setTimeout(this.getList,1000)
        })
        .catch(() => {});
      }else{
        this.paySH()
      }

    },
    agree(data){
      this.drawer=true
      this.agreeData=data
      this.getEXP(data.memberId)
    },
    getEXP(id){
      this.$http.post('/rest/experience/list', {objectId:id}, res => {
        this.exp=res
      })
    },
    handleClick(a){
      if(a.name=='first'){
        this.getList()
      }else{
        this.getList2()
      }
    },

    // searchCondition(){
    //   this.form.page=1
    //   this.getList()
    // },
    // handleCurrentChange(a){
    //   this.form.page=a
    //   this.getList()
    // },

    getTeam(){
      this.$http.post('/rest/team/detail', {teamId:this.$route.params.id}, res => {
        this.teamData=res
      })
    },
    getList(){
      this.needSH=0
      this.$http.post('/rest/team/member/list', this.form, res => {
        this.tableData=res.data
        this.form.total=res.total
        res.data.forEach(i=>{
          if(i.checkResult==0){
            this.needSH++
          }
        })
      })
    },
    look(data){
      this.imgUrl=data.payObjectkey
      this.$refs.lookImg.clickHandler()
    },
    getList2(){
      this.needSH2=0
      this.$http.post('/rest/team/pay/history', this.form2, res => {
        this.tableData2=res.data
        this.form2.total=res.total
        res.data.forEach(i=>{
          if(i.checkResult==0){
            this.needSH2++
          }
        })
      })
    },
    // toDetail(id){
    //  this.openNewPage('/manage/documentdetail/'+id)
    // }
  }
}
</script>

<style scoped>
.value{
  display:inline-block;
  vertical-align: middle;
  width: 150px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.label{
  display: inline-block;
  text-align: justify;
  text-align-last: justify;
  width: 90px;

  /*text-align: justify-all;*/
}
/deep/ .el-tabs__nav-scroll,/deep/ .el-tabs__nav-wrap{
  overflow: visible;
}
/deep/ .el-tabs__nav-wrap::after{
  background-color: transparent;
}
/deep/ .el-badge__content.is-fixed{
  top:6px
}
.memberPhoto{
  display: block;
  width: 50px;
  height: 50px;
  border-radius: 50px;
}
</style>



// WEBPACK FOOTER //
// src/view/vipManagement/team/detail.vue